import { assetFolderMapper, assetsMapper, contentItemsMapper, contentTypeMapper, contentTypeSnippetMapper, elementsMapper, languageMapper, languageVariantMapper, projectMapper, taxonomyMappper, webhookMapper, workflowMapper, } from '../mappers';
export class MappingService {
    constructor() {
        this.assetFoldersMapper = assetFolderMapper;
        this.assetsMapper = assetsMapper;
        this.contentItemsMapper = contentItemsMapper;
        this.contentTypeMapper = contentTypeMapper;
        this.contentTypeSnippetMapper = contentTypeSnippetMapper;
        this.elementsMapper = elementsMapper;
        this.languageMapper = languageMapper;
        this.languageVariantMapper = languageVariantMapper;
        this.projectMapper = projectMapper;
        this.taxonomyMapper = taxonomyMappper;
        this.webhookMapper = webhookMapper;
        this.workflowMapper = workflowMapper;
    }
}
//# sourceMappingURL=mapping-service.class.js.map